export default __webpack_public_path__ + "static/media/1471.debad69e.png";